import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import routes from '~/routes';
import EvaluationCasesContent from './evaluation-cases-content';

const EvaluationCasesPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>{pageTitle('Evaluation Case Management')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Evaluation Case Management"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newEvaluationCasePath)}
          >
            Create Case
          </Button>
        }
      />
      <EvaluationCasesContent />
    </>
  );
};

export { EvaluationCasesPage };
